import React from "react";
import { Tooltip } from "antd";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppIcon from "components/ui/AppIcon";
import {
  SVG_DRAGDROP,
} from "svg/SVGs";

const ItemRow = ({ item, deleteItem, handleStores, index }) => {
  const router = useHistory();
  const { t } = useTranslation();

  const updateItem = (id) => {
    router.push("/app/dashboard/updateitem/", {
      itemId: id,
    });
  };

  return (
    <div
      key={item.itemId._id}
      className="grid grid-cols-3 items-center gap-3 border-b border-secondary-light bg-primary-light px-4 py-3 text-16px text-gray-700"
    >
      <div className="flex items-center gap-3 border-r border-gray-800 ">
        <div className=" h-5 w-5 cursor-move items-center justify-center text-gray-500">
          <SVG_DRAGDROP />
        </div>
        <div className="min-w-0">
          <h3 className="m-0 truncate p-0 text-18px font-medium text-gray-900">
            {item.itemId.baseLanguage.title}
          </h3>
        </div>
      </div>
      <div className="w-[140px] text-center text-18px font-medium text-gray-800 border-r border-gray-800">
        {item.itemId.price + " " + t("AED")}
      </div>
      <div className="flex w-[180px] text-center items-center justify-center gap-3">
        <Tooltip placement="topRight" title={t("Stores")}>
          <button
            className="rounded p-1 text-gray-900 transition hover:bg-gray-100"
            onClick={() => {
              handleStores(item, index);
            }}
          >
            <AppIcon name="eye" size={19} />
          </button>
        </Tooltip>
        <Tooltip placement="topRight" title={t("Edit")}>
          <button
            className="rounded p-1 text-gray-900 transition hover:bg-gray-100"
            onClick={() => updateItem(item.itemId._id)}
          >
            <AppIcon name="edit" size={19} />
          </button>
        </Tooltip>
        <Tooltip placement="topRight" title={t("Remove")}>
          <button
            className="rounded p-1 text-gray-900 transition hover:bg-gray-100"
            onClick={() => deleteItem(item.itemId, index)}
          >
            <AppIcon name="trash" size={19} />
          </button>
        </Tooltip>
      </div>
    </div>
  );
};
export default ItemRow;
ItemRow.propTypes = {
  item: PropTypes.object,
  deleteItem: PropTypes.func,
  handleStores: PropTypes.func,
  index: PropTypes.number,
};
